import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { layoutDefaults } from '../../utils/layout-defaults';
import { WalletType } from '../../utils/manager/card-manager';
import { PrivacyNotice } from '../privacy-notice';
import applePayIconData from './apple-pay.json';
import googlePayIconData from './google-pay.json';

function PaymentWalletModalTitle({
  wallet,
  subTitle,
  className,
  style,
  getPrivacyPolicyFromRemote,
  analytics,
}) {
  const classes = useStyles({ subTitle, wallet });

  return (
    <div className={classNames(classes.container, className)} style={style}>
      <Lottie
        play
        loop={false}
        animationData={
          wallet === WalletType.APPLE_PAY ? applePayIconData : googlePayIconData
        }
        className={classes.icon}
      />
      {/* <FadeIn delay={150}>
        <div className={classes.title}>{title}</div>
      </FadeIn> */}
      <FadeIn delay={200}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getPrivacyPolicyFromRemote}
        />
      </FadeIn>
      {/* <FadeIn>
        <div className={_.isEmpty(subTitle) ? classes.subTitle : classes.title}>
          {title}
        </div>
        <div className={classes.subTitle}>{subTitle}</div>
    </FadeIn> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: "1px solid white",
    marginLeft: layoutDefaults.smallHorizontalMargin,
    marginRight: layoutDefaults.smallHorizontalMargin,
  },
  // title: {
  //   fontSize: layoutDefaults.biggerFontSize,
  // },
  // subTitle: {
  //   fontSize: layoutDefaults.biggestFontSize,
  // },

  icon: {
    height: ({ wallet }) => (wallet === WalletType.GOOGLE_PAY ? 44 : 40),
    marginTop: -layoutDefaults.smallerVerticalMargin,
    marginBottom: ({ wallet }) => (wallet === WalletType.GOOGLE_PAY ? 0 : 6),
  },

  title: {
    fontSize: layoutDefaults.biggestFontSize,
    fontWeight: 'bold',
    marginTop: -layoutDefaults.bigVerticalMargin,
  },

  // title: {
  //   // fontSize: layoutDefaults.biggerFontSize,
  //   fontSize: ({ subTitle }) =>
  //     (subTitle?.length ?? 0) < 10
  //       ? layoutDefaults.biggerFontSize
  //       : layoutDefaults.biggestFontSize,
  // },
  subTitle: {
    fontSize: ({ subTitle }) =>
      (subTitle?.length ?? 0) < 10
        ? layoutDefaults.biggestFontSize
        : layoutDefaults.biggerFontSize,
  },
});

export { PaymentWalletModalTitle };
